import { use } from "react";
import { IndexDBContext } from "./IndexDBContext";

export function useIndexDB() {
  const indexDBContext = use(IndexDBContext);

  if (!indexDBContext) {
    throw new Error("This Hook must be used under IndexDBProvider!");
  }

  return indexDBContext;
}
